import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between" }
const _hoisted_2 = { class: "flex items-center justify-between w-full" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h6", { class: "mr-3 font-normal" }, "Tracking Kurir ", -1)
const _hoisted_4 = { class: "text-sm color-blue-grey" }
const _hoisted_5 = { class: "font-semibold" }
const _hoisted_6 = {
  key: 0,
  class: "font-semibold"
}
const _hoisted_7 = {
  key: 1,
  class: "font-semibold"
}
const _hoisted_8 = {
  key: 0,
  class: "font-semibold"
}
const _hoisted_9 = {
  key: 1,
  class: "font-semibold"
}
const _hoisted_10 = {
  key: 0,
  class: "font-semibold"
}
const _hoisted_11 = {
  key: 1,
  class: "font-semibold"
}
const _hoisted_12 = {
  key: 0,
  class: "font-semibold"
}
const _hoisted_13 = {
  key: 1,
  class: "font-semibold"
}
const _hoisted_14 = { class: "p-3" }
const _hoisted_15 = /*#__PURE__*/_createVNode("p", { class: "text-white font-bold text-sm text-center" }, "Simpan", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Card = _resolveComponent("Card")
  const _component_InputNumber = _resolveComponent("InputNumber")
  const _component_Button = _resolveComponent("Button")
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")

  return (_openBlock(), _createBlock("section", null, [
    _createVNode(_component_Card, null, {
      title: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _hoisted_3,
            _createVNode("p", _hoisted_4, _toDisplayString(`Hari Ini, ${_ctx.moment().format('DD MMMM YYYY')}`), 1)
          ])
        ])
      ]),
      content: _withCtx(() => [
        _createVNode(_component_DataTable, {
          value: _ctx.data,
          paginator: false,
          stripedRows: "",
          class: "table-og",
          responsiveLayout: "scroll"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              header: "Nama Kurir",
              style: {"width":"20%"}
            }, {
              body: _withCtx((slotProps) => [
                _createVNode("p", _hoisted_5, _toDisplayString(slotProps.data?.KurirMsUser?.Fullname), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              header: "Total Assigned",
              style: {"width":"20%"}
            }, {
              body: _withCtx((slotProps) => [
                (slotProps.data?.TotalAssign)
                  ? (_openBlock(), _createBlock("p", _hoisted_6, _toDisplayString(`${slotProps.data?.TotalAssign}(${slotProps.data?.BeratAssign} Kg)`), 1))
                  : (_openBlock(), _createBlock("p", _hoisted_7, "-"))
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              header: "Belum Scan Barang",
              style: {"width":"20%"}
            }, {
              body: _withCtx((slotProps) => [
                (slotProps.data?.TotalBelumScan)
                  ? (_openBlock(), _createBlock("p", _hoisted_8, _toDisplayString(`${slotProps.data?.TotalBelumScan}(${slotProps.data?.BeratBelumScan} Kg)`), 1))
                  : (_openBlock(), _createBlock("p", _hoisted_9, "-"))
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              header: "Kembali Ke Agen",
              style: {"width":"20%"}
            }, {
              body: _withCtx((slotProps) => [
                (slotProps.data?.TotalKembali)
                  ? (_openBlock(), _createBlock("p", _hoisted_10, _toDisplayString(`${slotProps.data?.TotalKembali}(${slotProps.data?.BeratKembali} Kg)`), 1))
                  : (_openBlock(), _createBlock("p", _hoisted_11, "-"))
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              header: "Diterima",
              style: {"width":"20%"}
            }, {
              body: _withCtx((slotProps) => [
                (slotProps.data?.TotalDone)
                  ? (_openBlock(), _createBlock("p", _hoisted_12, _toDisplayString(`${slotProps.data?.TotalDone}(${slotProps.data?.BeratDone} Kg)`), 1))
                  : (_openBlock(), _createBlock("p", _hoisted_13, "-"))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"])
      ]),
      _: 1
    }),
    _createVNode(_component_OverlayPanel, { ref: "refChangeKuota" }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_14, [
          _createVNode(_component_InputNumber, {
            class: "input-primary rounded-lg mt-1 mb-3",
            modelValue: _ctx.dataForm.Kuota,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.dataForm.Kuota = $event)),
            showButtons: "",
            buttonLayout: "horizontal",
            incrementButtonIcon: "pi pi-plus",
            decrementButtonIcon: "pi pi-minus",
            min: 0,
            placeholder: "Kuota"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_Button, {
            class: "font-semibold btn-primary p-button-sm w-full flex justify-center",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.submit()))
          }, {
            default: _withCtx(() => [
              _hoisted_15
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 512)
  ]))
}